/* Ganga V2 (12/10/2026): guardia de talle del botón PRINCIPAL de la ficha.
   Igual que la barra fija (tanda 1) y la vista rápida (gs-card.js): en productos con opción de talle de 2 o más
   valores el tema marca solo el primero. Hasta que la persona toca un talle, el botón dice "Elegí tu talle" y al
   tocarlo marca el selector (aviso rojo + pulso) en vez de agregar. "Comprar ahora" (pago dinámico, si se prende)
   queda apagado y frenado igual. Si el selector de talle no se ve (lo oculta una app), no se traba la compra.
   Un solo estado para toda la ficha: el atributo data-gs-talle-pend del product-info principal. La barra fija
   (sticky-atc-bar-minimalist.js) lo lee con window.GsTalle y se repinta con el evento "gs:talle". */
(function () {
  if (window.GsTalle) return;
  var TALLE = /^\s*(talla|talle|size)/i;
  var TEXTO = 'Elegí tu talle';

  function principal() {
    return document.querySelector('product-info[id^="MainProduct-"]');
  }
  function grupoTalle(info) {
    var grupos = info ? info.querySelectorAll('variant-selects .product-form__input') : [];
    for (var i = 0; i < grupos.length; i++) {
      var l = grupos[i].querySelector('[data-selected-swatch-value]');
      if (l && TALLE.test(l.getAttribute('data-selected-swatch-value') || '')) return grupos[i];
    }
    return null;
  }
  function opciones(g) {
    var s = g.querySelector('select');
    return g.querySelectorAll('input[type="radio"]').length || (s ? s.options.length : 0);
  }
  function formulario(info) {
    return document.getElementById('product-form-' + info.dataset.section) ||
      info.querySelector('form[data-type="add-to-cart-form"]');
  }
  function pendiente(info) {
    info = info || principal();
    return !!(info && info.hasAttribute('data-gs-talle-pend'));
  }

  function pintar(info) {
    var pend = pendiente(info);
    info.classList.toggle('gs-talle-pend', pend);
    var f = formulario(info);
    var b = f && f.querySelector('[name="add"]');
    var txt = b && b.querySelector('.btn__text');
    if (txt) {
      var cta = b.querySelector('.gs-size-cta');
      /* Con el botón apagado (variante agotada) se ve el texto del tema ("Agotado"), no el aviso */
      var mostrar = pend && !b.disabled;
      if (mostrar && !cta) {
        cta = document.createElement('span');
        cta.className = 'btn__text gs-size-cta';
        cta.textContent = TEXTO;
        txt.insertAdjacentElement('afterend', cta);
      }
      txt.style.display = mostrar ? 'none' : '';
      if (cta) cta.style.display = mostrar ? '' : 'none';
    }
    if (!pend) {
      var avisos = info.querySelectorAll('.gs-size-hint');
      for (var i = 0; i < avisos.length; i++) avisos[i].remove();
    }
    document.dispatchEvent(new CustomEvent('gs:talle', { detail: { pendiente: pend } }));
  }

  function soltar(info) {
    if (!pendiente(info)) return;
    info.removeAttribute('data-gs-talle-pend');
    pintar(info);
  }

  /* Marca el selector: aviso "Elegí tu talle" en la etiqueta y un pulso rojo. Solo se desplaza si el selector no
     está entero en la pantalla (desde la barra fija); desde el botón principal queda donde está. */
  function marcar(info, g) {
    var lab = g.querySelector('.form__label');
    if (lab && !lab.querySelector('.gs-size-hint')) {
      var s = document.createElement('span');
      s.className = 'gs-size-hint';
      s.textContent = TEXTO;
      lab.appendChild(s);
    }
    g.classList.remove('gs-size-pulse');
    setTimeout(function () { g.classList.add('gs-size-pulse'); }, 30);
    setTimeout(function () { g.classList.remove('gs-size-pulse'); }, 2000);
    var r = g.getBoundingClientRect();
    if (r.top < 90 || r.bottom > window.innerHeight - 90) {
      window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - 160), behavior: 'smooth' });
    }
  }

  /* Devuelve true si frenó la compra (y marcó el selector). Si el selector no se ve, suelta la guardia. */
  function frenar(info) {
    info = info || principal();
    if (!pendiente(info)) return false;
    var g = grupoTalle(info);
    if (g && g.getClientRects().length) {
      marcar(info, g);
      return true;
    }
    soltar(info);
    return false;
  }

  function estilos() {
    if (document.getElementById('gs-size-guard-css')) return;
    var st = document.createElement('style');
    st.id = 'gs-size-guard-css';
    st.textContent =
      '.gs-size-pulse{border-radius:10px;animation:gsSizePulse 1.8s ease-out 1}' +
      '@keyframes gsSizePulse{0%,55%{box-shadow:0 0 0 4px rgba(255,96,96,.85)}100%{box-shadow:0 0 0 4px rgba(255,96,96,0)}}' +
      '.gs-size-hint{display:block;flex-basis:100%;margin-top:.2rem;font-size:13px;font-weight:700;color:#d63b3b}' +
      '.gs-talle-pend .shopify-payment-button{opacity:.4}';
    document.head.appendChild(st);
  }

  function init() {
    var info = principal();
    if (!info || info.__gsTalle) return;
    var g = grupoTalle(info);
    if (!g || opciones(g) < 2) return;
    info.__gsTalle = true;
    estilos();
    info.setAttribute('data-gs-talle-pend', '');

    /* Tocar cualquier talle (también el que ya estaba marcado) cuenta como elegirlo */
    var elegir = function (e) {
      if (!pendiente(info) || !e.target || !e.target.closest) return;
      var campo = e.target.closest('input, label, select');
      var grupo = grupoTalle(info);
      if (campo && grupo && grupo.contains(campo)) soltar(info);
    };
    info.addEventListener('click', elegir);
    info.addEventListener('change', elegir);

    /* "Comprar ahora": fase de captura, corta el clic antes de que llegue al botón de Shopify */
    info.addEventListener('click', function (e) {
      if (!pendiente(info) || !e.target.closest || !e.target.closest('.shopify-payment-button')) return;
      if (frenar(info)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* Botón principal (y Enter): antes de que el product-form del tema reciba el submit */
    document.addEventListener('submit', function (e) {
      if (e.target !== formulario(info) || !pendiente(info)) return;
      if (frenar(info)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    /* El tema cambia el texto y el estado del botón al cambiar de variante: se vuelve a pintar */
    document.addEventListener('variant:changed', function () { pintar(info); });

    pintar(info);
  }

  window.GsTalle = {
    pendiente: function () { return pendiente(); },
    frenar: function () { return frenar(); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
